import { render, staticRenderFns } from "./OrderCreateInfo.vue?vue&type=template&id=d51f08a6&scoped=true"
import script from "./OrderCreateInfo.vue?vue&type=script&lang=js"
export * from "./OrderCreateInfo.vue?vue&type=script&lang=js"
import style0 from "./OrderCreateInfo.vue?vue&type=style&index=0&id=d51f08a6&lang=scss"
import style1 from "./OrderCreateInfo.vue?vue&type=style&index=1&id=d51f08a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51f08a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d51f08a6')) {
      api.createRecord('d51f08a6', component.options)
    } else {
      api.reload('d51f08a6', component.options)
    }
    module.hot.accept("./OrderCreateInfo.vue?vue&type=template&id=d51f08a6&scoped=true", function () {
      api.rerender('d51f08a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/OrderCreateInfo.vue"
export default component.exports